var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('notifications'),_c('loader'),_c('Navbar'),_c('Notificationbar'),_c('router-view'),_c('Footer'),_c('SessionTimeOutModalManager')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }